import React, { Component } from 'react';
import { message } from 'antd';
import { queryMaterialBorrowInfo } from '@api/administrative/material';
import localDb from '@util/localDb';
import PageEdit from './PageEdit';
import PageOpen from './PageOpen';

class PageInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  componentWillMount() {
    this.userUuid = localDb.get('userUuid');
  }

  componentDidMount() {
    this.getMaterialBorrowInfo();
  }

  getMaterialBorrowInfo = () => {
    queryMaterialBorrowInfo({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.state;
    // return <PageOpen data={dataInfo} {...this.props} />;
    if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
      return <PageEdit data={dataInfo} {...this.props} />;
    }
    if (dataInfo.uuid) {
      return <PageOpen data={dataInfo} {...this.props} />;
    }
    return <span />;
  }
}
export default PageInfo;



// WEBPACK FOOTER //
// ./src/components/administrative/material/borrow/PageInfo.js